module.exports = __webpack_public_path__ + "static/media/artist_02.6a9b3390.png";